export const INITIAL_ACCOUNT_USER_ROLES = ['5a564859095cc45ad38afbf7'];
export const PUBLISHER_ORG = '5ab7b88bb0feefb51afc5209';
export const DATE_FIELDS = ['created', 'updated', 'date', 'from', 'to'];